import { Flex, Text, Title } from '@mantine/core';
import { FC } from 'react';
import { TitleDescriptionLiveBlogProps } from './types';
import { useStyles } from './styles';

export const TitleDescriptionLiveBlog: FC<TitleDescriptionLiveBlogProps> = ({
  title,
  description,
  titleDirect,
}) => {
  const { classes } = useStyles();

  return (
    <Flex direction="column" gap="xs">
      <Flex direction="row">
        <Title variant="h1Orange" order={1}>
          {titleDirect} <span className={classes.span}>{title}</span>
        </Title>
      </Flex>
      <Text mt={16} variant="body2" component="p">
        {description}
      </Text>
    </Flex>
  );
};
